const EMPTY_HIDDEN_METRICS = [];

const EMPTY_TOUCH_POINT_TARGETS = [];

const getSettings = (state) => state.cache.adebifyCustomReport.settings;
const getMode = (state) => state.cache.adebifyCustomReport.settings.mode;
const getRowDimensions = (state) =>
  state.cache.adebifyCustomReport.settings.rowDimensions;
const getColumnDimensions = (state) =>
  state.cache.adebifyCustomReport.settings.columnDimensions;
const getMetrics = (state) => state.cache.adebifyCustomReport.settings.metrics;
const getAxis = (state) => state.cache.adebifyCustomReport.settings.axis;
const getProductAxis = (state) =>
  state.cache.adebifyCustomReport.settings.productAxis;
const getFilters = (state) =>
  state.cache.adebifyCustomReport.settings.filters;
const getTouchPointTargets = (state) =>
  state.cache.adebifyCustomReport.settings.touchPointTargets ?? EMPTY_TOUCH_POINT_TARGETS;
const getCvDisplayColumns = (state) =>
  state.cache.adebifyCustomReport.settings.cvDisplayColumns;

const getTableData = (state) => state.cache.adebifyCustomReport.table.data.list;
const getTableSum = (state) => state.cache.adebifyCustomReport.table.data.sum;
const getPivotColumns = (state) =>
  state.cache.adebifyCustomReport.table.data.pivotColumns;
const getSort = (state) => state.cache.adebifyCustomReport.table.settings.sort;
const getPagination = (state) =>
  state.cache.adebifyCustomReport.table.settings.pagination;

const getStatus = (state) => state.cache.adebifyCustomReport.status;
const getFetchedMode = (state) => state.cache.adebifyCustomReport.fetchedMode;
const getFetchedSettings = (state) => state.cache.adebifyCustomReport.fetchedSettings;
const getFetchedMeta = (state) => state.cache.adebifyCustomReport.fetchedMeta;
const getHiddenMetrics = (state) =>
  state.cache.adebifyCustomReport.fetchedMeta?.hiddenMetrics ?? EMPTY_HIDDEN_METRICS;
const getError = (state) => state.cache.adebifyCustomReport.error;

const getIsLoading = (state) =>
  state.cache.adebifyCustomReport.status === 'loading';

export default {
  getSettings,
  getMode,
  getRowDimensions,
  getColumnDimensions,
  getMetrics,
  getAxis,
  getProductAxis,
  getFilters,
  getTouchPointTargets,
  getCvDisplayColumns,
  getTableData,
  getTableSum,
  getPivotColumns,
  getSort,
  getPagination,
  getStatus,
  getFetchedMode,
  getFetchedSettings,
  getFetchedMeta,
  getHiddenMetrics,
  getError,
  getIsLoading,
};
